import Popup from 'semantic-ui-react/dist/commonjs/modules/Popup';
import { withMountNode } from '../../utils/modals';

export default withMountNode(Popup, 'alt');
